import CustomDrawer from './custom_drawer'
import { connect } from 'react-redux';
import * as generalAction from '../../redux/action/general_action'

const mapDispatchToProps = (dispatch) => {
	return {
		setDrawer: (open) => dispatch(generalAction.setOpenDrawer(open))
	}
}

const mapStateToProps=(state)=>{
    return {
            generalState:state.general_reducer
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(CustomDrawer)